
import { useEffect, useState } from "react";
import { FiChevronDown, FiArrowRight } from "react-icons/fi";
import { FaRegCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import { BsFillSuitcaseLgFill } from "react-icons/bs";
import axios from "axios";
import { useScreen } from "../../context/ScreenContext";

const BackgroundImg = "https://storage.googleapis.com/think41-web-new/assets/Career/Background.png";

const API_BASE = import.meta.env.VITE_API_BASE_URL;

const JobOpening = () => {
  const { isMobile } = useScreen();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_BASE}jobs`)
      .then((res) => {
        setJobs(
          res.data.map((job) => ({
            id: job.id,
            title: job.title,
            experience: job.yoe,
            responsibility: job.job_type,
            location: job.job_location,
            applyLink: job.link,
          }))
        );
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setJobs([]);
        console.error("Failed to fetch jobs:", error);
      });
  }, []);

  return (
    <div
      id="jobOpening"
      style={{
        backgroundImage: `url(${BackgroundImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
        minHeight: "33vh",
        overflowX: "hidden",
      }}
    >
      <section className="flex flex-col items-center w-full max-w-[1200px] md:mt-12 relative z-[1] px-4 md:px-0 mx-auto">
        <div style={{ height: 27 }} />
        <div
          className={`flex flex-col md:flex-row items-center justify-between w-full mb-8 ${
            isMobile && "gap-[20px]"
          }`}
        >
          <h2 className="font-montserrat font-semibold text-[24px] leading-[53px] text-white md:w-[320px] md:text-[40px] md:leading-[53px] text-start w-full">
            Open <span className="font-montserrat">positions</span>
          </h2>

          <div className="flex items-center gap-[20px] w-full md:max-w-max relative">
            <span className="text-white font-montserrat text-[14px] font-medium leading-[22.5px]">
              Filter by
            </span>
            <div className="relative w-[227px]">
              <select
                name="department"
                id="department"
                defaultValue=""
                className="w-full border border-black/10 rounded-[5px] px-[11px] py-[6.75px] pr-8 cursor-pointer text-[15px] font-montserrat text-black/60 appearance-none bg-white"
              >
                <option value="">Department</option>
                <option value="engineering">Engineering</option>
                <option value="hr">HR</option>
                <option value="manager">Manager</option>
              </select>
              <FiChevronDown
                size={18}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-black/60 pointer-events-none"
              />
            </div>
          </div>
        </div>

        {/* Job Cards */}
        <div className="flex flex-col gap-6 w-full max-w-full">
          {loading && (
            <p className="text-center text-white text-xl py-8">Loading job openings...</p>
          )}
          {!loading && jobs.length === 0 && (
            <p className="text-center text-white text-xl py-8">No job openings at the moment.</p>
          )}
          {jobs.map((job) => (
            <div
              key={job.id}
              className="flex justify-between items-start w-full max-w-full rounded-[8px] bg-[#E2EBF9] px-6 pt-[18px] pb-[28px] flex-wrap"
            >
              <div className="flex flex-col gap-3">
                <div className="font-roboto font-medium text-[24px] text-[#111]">
                  {job.title}
                </div>
                <div className="flex items-center flex-wrap text-[#111] text-[15px] font-montserrat space-x-4">
                  <div className="flex items-center gap-1">
                    <FaRegCalendarAlt />
                    <span>{job.experience}</span>
                  </div>
                  <span className="text-black/40 md:inline hidden">|</span>
                  <div className="flex items-center gap-1">
                    <FaMapMarkerAlt />
                    <span>{job.location}</span>
                  </div>
                  <span className="text-black/40 md:inline hidden">|</span>
                  <div className="flex items-center gap-1">
                    <BsFillSuitcaseLgFill />
                    <span>{job.responsibility}</span>
                  </div>
                </div>
              </div>

              {/* Apply Now Button */}
              <div className="mt-[4px]">
                <a
                  href={job.applyLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <button className="bg-[#0060C7] text-white rounded-full px-2 py-2 cursor-pointer flex items-center gap-2 hover:opacity-90 transition">
                    <span className="bg-white text-[#0047FF] w-6 h-6 flex items-center justify-center rounded-full">
                      <FiArrowRight size={14} strokeWidth={3} />
                    </span>
                    <span className="font-montserrat font-medium text-base">
                      Apply Now
                    </span>
                  </button>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div style={{ height: 63 }} />
      </section>
    </div>
  );
};

export default JobOpening;




